/*=========================================================================================
  File Name: moduleCompanyMutations.js
  Description: Company Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
	ADD_RESOURCE(state, item) {
		state.resources.unshift(item);
	},
	SET_RESOURCES(state, items) {
		state.resources = [...items];
	},
	UPDATE_RESOURCE(state, payload) {
		const ItemIndex = state.resources.findIndex((vh) => vh.id === payload.id);
		if (ItemIndex !== -1) {
			Object.assign(state.resources[ItemIndex], payload);
		}
	},
	REMOVE_RESOURCE(state, itemId) {
		const ItemIndex = state.resources.findIndex((vh) => vh.id === itemId);
		state.resources.splice(ItemIndex, 1);
	},
	REMOVE_ALL_RESOURCES(state) {
		state.resources = [];
	},
	SELECTED_RESOURCE(state, resorce) {
		state.currentResourceId = resorce.id;
		state.currentResource = {...resorce};
	},
	ADD_RESOURCE_CHECKED(state, item) {
		const itemIndex = state.checkedResources.findIndex((p) => p.id === item.id);
		if (itemIndex === -1) {
			state.checkedResources.push(item);
		}
	},
	SET_RESOURCE_CHECKED(state, resource) {
		state.checkedResources = resource;
	},
	DEL_RESOURCE_CHECKED(state, item) {
		const itemIndex = state.checkedResources.findIndex((p) => p.id === item.id);
		if (itemIndex >= 0) {
			state.checkedResources.splice(itemIndex, 1);
		}
	},
	REMOVE_ALL_RESOURCE_CHECKED(state) {
		state.checkedResources = [];
	},
};
